import { create } from 'zustand';

interface AppState {
  // Placeholder for global UI state — populated in later prompts.
  ready: boolean;
  setReady: (ready: boolean) => void;
  reset: () => void;
}

const initialState = {
  ready: false,
};

export const useAppStore = create<AppState>((set) => ({
  ...initialState,
  setReady: (ready) => set({ ready }),
  reset: () => set(initialState),
}));
